import { solicitar } from '../identidad/cliente-identidad.js'
export type TipoProyecto = 'INVESTIGACION' | 'INTERVENCION'
export interface DatosRae {
  nombreProyecto: string
  integrantes: string
  tipoProyecto: TipoProyecto
  problema: string
  meta: string
  objetivos: string
  rastreoAntecedentes: string
  marcoTeorico: string
  metodologia: string
  aportes: string
  bibliografia: string
}
export interface Proyecto extends DatosRae {
  id: string
  informeResultado: string | null
  version: number
  etapaConsulta: string
  evidencias: Array<{ id: string; nombreOriginal: string; mime: string; tamano: number }>
}
export function obtenerProyecto(id: string) {
  return solicitar<{ datos: Proyecto | null }>(`/api/v1/expedientes/${id}/proyecto`)
}
export function guardarRae(id: string, datos: DatosRae) {
  return solicitar<void>(`/api/v1/expedientes/${id}/proyecto/rae`, {
    method: 'PUT',
    body: JSON.stringify(datos),
  })
}
export function guardarInforme(id: string, informeResultado: string, version: number) {
  return solicitar<void>(`/api/v1/expedientes/${id}/proyecto/informe`, {
    method: 'PUT',
    body: JSON.stringify({ informeResultado, version }),
  })
}
export function agregarEvidencia(id: string, evidencia: File) {
  const cuerpo = new FormData()
  cuerpo.append('evidencia', evidencia)
  return solicitar<{ estado: string }>(`/api/v1/expedientes/${id}/proyecto/evidencias`, {
    method: 'POST',
    body: cuerpo,
  })
}
